import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
      name: "notification",
      initialState: {
            newNotification: true,
      },


      reducers: {
            updateNotification: (state, action) => {
                  state.newNotification = action.payload;
            }
      }
});

export default notificationSlice.reducer;
export const { updateNotification } = notificationSlice.actions;